import React from 'react'
import AllInformation from '../information/AllInformation';
import { Route, Routes } from 'react-router-dom';

const InformationRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/all-information" element={<AllInformation />} />
            </Routes>
        </>
    )
}

export default InformationRoutes;